import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { USER_ROLES } from "@/constants/auth";
const variantStyles = {
    success: {
        container: "bg-green-100 text-green-800",
        dot: "bg-green-400"
    },
    error: {
        container: "bg-red-100 text-red-800",
        dot: "bg-red-400"
    },
    warning: {
        container: "bg-yellow-100 text-yellow-800",
        dot: "bg-yellow-400"
    },
    info: {
        container: "bg-blue-100 text-blue-800",
        dot: "bg-blue-400"
    },
    purple: {
        container: "bg-purple-100 text-purple-800",
        dot: "bg-purple-400"
    },
    gray: {
        container: "bg-gray-100 text-gray-800",
        dot: "bg-gray-400"
    }
};
export const Badge = ({ children, variant, showDot = false })=>{
    const styles = variantStyles[variant];
    return /*#__PURE__*/ _jsxs("span", {
        className: `inline-flex shrink-0 items-center whitespace-nowrap px-2.5 py-0.5 rounded-full text-xs font-medium ${styles.container}`,
        children: [
            showDot && styles.dot && /*#__PURE__*/ _jsx("span", {
                className: `w-2 h-2 rounded-full mr-1.5 ${styles.dot}`
            }),
            children
        ]
    });
};
export const StatusBadge = ({ status })=>{
    const isActive = status === "Active";
    const variant = isActive ? "success" : "error";
    return /*#__PURE__*/ _jsx(Badge, {
        variant: variant,
        showDot: true,
        children: status.toUpperCase()
    });
};
export const RoleBadge = ({ role })=>{
    const variantMap = {
        [USER_ROLES.ADMIN]: "purple",
        [USER_ROLES.USER]: "info",
        [USER_ROLES.VIEWER]: "gray",
        [USER_ROLES.SUPERADMIN]: "error"
    };
    // Fallback to 'info' variant if role is not in the map
    const variant = variantMap[role] || "info";
    return /*#__PURE__*/ _jsx(Badge, {
        variant: variant,
        children: role || USER_ROLES.USER
    });
};
export const UserStatusBadge = ({ status })=>{
    const variantMap = {
        ACTIVE: "success",
        INACTIVE: "gray",
        PENDING: "warning"
    };
    return /*#__PURE__*/ _jsx(Badge, {
        variant: variantMap[status],
        children: status
    });
};
